import { pubsub } from '@services';

class MenuPanes extends HTMLElement {
  pane;

  connectedCallback() {
    this.panes = this.querySelectorAll('[aria-hidden]');

    this.addEventListener('click', (event) => {
      // Handle click on a back button
      const backLink = event.target.closest('[data-back-button]');
      if (backLink) {
        this.handleBackLinkClick(backLink);
        return;
      }

      // Handle click on a parent link
      const parentLink = event.target.closest('a[data-target-id]');
      if (parentLink) {
        this.handleParentLinkClick(parentLink, event);
      }
    });

    // After a pane open-transition ends, update the trap container elements
    this.addEventListener('transitionend', (event) => {
      if (event.target.getAttribute('aria-hidden') !== 'false') return;
      const paneToTrapFocus = this.querySelector(
        '[aria-hidden="false"]:not(:has([aria-hidden="false"]))'
      );
      this.updateTrapContainerElements(paneToTrapFocus);
    });

    // When the drawer is closed, reset all panes
    this.unsubscribeDrawerClosed = pubsub.subscribe(`drawer:closed:menu-drawer`, () => {
      this.resetPanes();
    });
  }

  disconnectedCallback() {
    this.unsubscribeDrawerOpened();
    this.unsubscribeDrawerClosed();
  }

  /**
   * Handle click on a Parent link
   * @param {HTMLElement} element - The parent link element
   * @param {MouseEvent} event - The click event
   */
  handleParentLinkClick(element, event) {
    event.preventDefault();
    this.pane = element.nextElementSibling;
    this.togglePanes();
  }

  /**
   * Handle click on a Back link
   * @param {HTMLElement} element - The back link element
   */
  handleBackLinkClick(element) {
    this.pane = element.closest('[aria-hidden]');
    this.togglePanes();
  }

  /**
   * Open the pane
   */
  openPane() {
    if (!this.pane) return;
    this.pane.ariaHidden = 'false';
  }

  /**
   * Close the pane
   */
  closePane() {
    if (!this.pane) return;

    // Set focus on the parent pane before closing this one
    const parentPane = this.pane.parentElement.closest('[aria-hidden]');
    this.updateTrapContainerElements(parentPane);

    this.pane.ariaHidden = 'true';
  }

  /**
   * Update the trap container elements so it only focuses the visible pane
   * @param {HTMLElement} element - The element to focus
   */
  updateTrapContainerElements(pane) {
    this.parentDrawer = this.parentDrawer || this.closest('drawer-element');
    this.parentDrawer.updateTrapContainerElements(pane);
  }

  /**
   * Toggle the panes
   */
  togglePanes() {
    if (!this.pane) return;
    this.pane.ariaHidden === 'true' ? this.openPane() : this.closePane();
  }

  /**
   * Reset the panes when drawer closes
   */
  resetPanes() {
    const timeout = window.DEFAULT_ANIMATION_DURATION || 300;
    setTimeout(() => {
      this.panes.forEach((pane) => {
        pane.ariaHidden = 'true';
      });
    }, timeout);
  }
}

customElements.define('menu-panes', MenuPanes);
